import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Installs a global fetch() patch + proactive token-refresh timer so expired
// access tokens no longer cause data to silently stop loading app-wide.
// Must be imported before App so it's in place before any component fetches.
import './services/fetchInterceptor';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
